export default "__VITE_ASSET__efcbe68e__"